<template>
	<div>
		<div class="main-category"  v-loading="loading">
		<section
			:class="[
				'menu-container-hide', 'd-flex',
			]"
			>
			<div
				class="menu-btn-container d-flex align-center justify-center"
				:style="`color:${globalColors.primary}`"
				@click="toogleMenu"
			>
				<p class="menu-btn-text">Categorías</p>
			</div>
				<transition name="lateral" mode="out-in">
					<menu-web
						class="menu-cat-hide"
						v-if="show"
						:categories="eCategories"
						@category-changed="toogleMenu"
					/>
				</transition>
		</section>
		<section>
			<div>
				<h1 class="category-title">Resultados</h1>
				<div class="section-product">
					<div class="d-flex justify-end align-center mb-3">
						<el-pagination
							class="txt-right"
							layout="prev, pager, next"
							:total="getTotalProductsOfSearch"
							:page-size="limit"
							:current-page="getCurrentPage"
							@current-change="pageChange"
						/>
					</div>
					<products-sections/>
				</div>
			</div>
		</section>
		<app-footer />
	</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import loadProductsMixin from '@/mixins/loadProducts';
	import appFooter from '@/sections/Footer';
	import menuWeb from '@/components/menuWeb';
	import productsSections from '@/sections/Products';

	function created() {
		this.loadData();
	}

	async function loadData() {
		const params = {
			commerceId: this.getCommerceData.id,
		};
		const requests = [
			this.$httpQtc.get('e-categories-public', { params }),
		];
		([
			{ data: this.eCategories },
		] = await Promise.all(requests));
	}

	function toogleMenu() {
		this.show = !this.show;
	}

	function data() {
		return {
			show: false,
			eCategories: [],
		};
	}

	export default {
		name: 'products-results',
		components: {
			appFooter,
			menuWeb,
			productsSections,
		},
		computed: {
			...mapGetters([
				'getCommerceData',
				'getCurrentPage',
				'getTotalProductsOfSearch',
				'loading',
			]),
		},
		created,
		data,
		methods: {
			loadData,
			toogleMenu,
		},
		mixins: [loadProductsMixin],
	};
</script>

<style lang="scss" scoped>
	.main-container {
		position: relative;
	}

	.menu-container-hide {
		background-color: white;
		cursor: pointer;
		height: 42.7rem;
		position: absolute;
		left: 0%;
		top: 0;
		transition: right 200ms ease-in;
		z-index: 2;

		@media (max-width: 600px) {
			display: none;
		}
	}

	.show-menu {
		right: 88%;
	}

	.menu-btn-container {
		background-color: color(greyBack);
		font-family: font(avenirBold);
		font-size: size(msmall);
		width: 3rem;
		z-index: 9;
	}

	.menu-btn-text {
		transform: rotateZ(270deg);
	}

	.section-product {
		margin: 0 auto;
		max-width: 102.4rem;

		@media (max-width: 1100px) {
			margin: 0 3.5rem;
		}

		@media (max-width: 600px) {
			margin: 0 1rem;
		}
	}

	.category-title {
		border-bottom: 0.2rem solid color(textGrey);
		font-family: font(avenirBold);
		font-size: size(maxsmall);
		margin: 1rem 3.5rem 3.5rem;
		padding: 3rem 1rem 1rem;
	}

	.menu-cat-hide {
		box-shadow: 6px 8px 8px -6px rgba(0, 0, 0, 0.11);
		width: 26rem;
	}
</style>


// WEBPACK FOOTER //
// Products-result.vue?0e72775c